// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_1wRujuR9Y9R3XsoSJgLnE","active":"sqcMUzhHbadLv0rIXWty3","icon":"_3HAGZPkzylfDcYG5fW7NrN"};


//////////////////
// WEBPACK FOOTER
// ./components/Customers/presentational/TabBarItem.module.css
// module id = 2349
// module chunks = 1